// Import model
import { GeoJsonPoint } from '../models/GeoJsonPoint';

// Import base class serializer

// Import dependency types (models and enums used in properties)

// Import dependency serializers (for complex types)

// Import derived type serializers (for polymorphic deserialization)

/**
 * Serializer for GeoJsonPoint - handles JSON serialization and deserialization with type validation
 */
export class GeoJsonPointSerializer {
  /**
   * Deserializes a JSON string into a GeoJsonPoint instance
   */
  static deserialize(json: string): GeoJsonPoint {
    const obj = JSON.parse(json);
    return this.fromObject(obj);
  }

  /**
   * Deserializes a plain object into a GeoJsonPoint instance
   */
  static fromObject(obj: any): GeoJsonPoint {
    if (!obj) {
      throw new Error('Cannot deserialize null or undefined to GeoJsonPoint');
    }


    const instance: GeoJsonPoint = {
      coordinates: obj['coordinates'] ? (obj['coordinates'] as any[]).map((item: any) =>
        item as number
      ) : [] as any,
    };

    return instance;
  }

  /**
   * Deserializes a JSON string into an array of GeoJsonPoint instances
   */
  static deserializeArray(json: string): GeoJsonPoint[] {
    const arr = JSON.parse(json);
    if (!Array.isArray(arr)) {
      throw new Error('Expected JSON array');
    }
    return arr.map(obj => this.fromObject(obj));
  }

  /**
   * Serializes a GeoJsonPoint instance to a JSON string
   */
  static serialize(instance: GeoJsonPoint): string {
    return JSON.stringify(this.toObject(instance));
  }

  /**
   * Converts a GeoJsonPoint instance to a plain object
   */
  static toObject(instance: GeoJsonPoint): any {
    return {
      'coordinates': instance.coordinates?.map((item: any) =>
        item
      ),
    };
  }

  /**
   * Serializes an array of GeoJsonPoint instances to a JSON string
   */
  static serializeArray(instances: GeoJsonPoint[]): string {
    return JSON.stringify(instances.map(inst => this.toObject(inst)));
  }
}
